// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from './client';
import { client } from './client.gen';
import type { DeleteV1BusinessPartnerCurrentChangeData, DeleteV1BusinessPartnerCurrentChangeErrors, DeleteV1BusinessPartnerCurrentChangeResponses, DeleteV1BusinessPartnerCurrentRequestChangeOwnershipData, DeleteV1BusinessPartnerCurrentRequestChangeOwnershipErrors, DeleteV1BusinessPartnerCurrentRequestChangeOwnershipResponses, DeleteV1IdentityCurrentRequestBusinessPartnerByIdData, DeleteV1IdentityCurrentRequestBusinessPartnerByIdErrors, DeleteV1IdentityCurrentRequestBusinessPartnerByIdResponses, DeleteV1RequestBusinessPartnerByIdData, DeleteV1RequestBusinessPartnerByIdErrors, DeleteV1RequestBusinessPartnerByIdResponses, DeleteV1ServiceAgreementByIdData, DeleteV1ServiceAgreementByIdErrors, DeleteV1ServiceAgreementByIdResponses, GetV1BusinessPartnerCurrentChangeData, GetV1BusinessPartnerCurrentChangeErrors, GetV1BusinessPartnerCurrentChangeResponses, GetV1BusinessPartnerCurrentData, GetV1BusinessPartnerCurrentDivisionsData, GetV1BusinessPartnerCurrentDivisionsErrors, GetV1BusinessPartnerCurrentDivisionsResponses, GetV1BusinessPartnerCurrentErrors, GetV1BusinessPartnerCurrentMigrationCandidateUserByIdData, GetV1BusinessPartnerCurrentMigrationCandidateUserByIdErrors, GetV1BusinessPartnerCurrentMigrationCandidateUserByIdResponses, GetV1BusinessPartnerCurrentMigrationCandidateUsersData, GetV1BusinessPartnerCurrentMigrationCandidateUsersErrors, GetV1BusinessPartnerCurrentMigrationCandidateUsersResponses, GetV1BusinessPartnerCurrentRequestChangeOwnershipData, GetV1BusinessPartnerCurrentRequestChangeOwnershipErrors, GetV1BusinessPartnerCurrentRequestChangeOwnershipResponses, GetV1BusinessPartnerCurrentResponses, GetV1BusinessPartnersData, GetV1BusinessPartnersErrors, GetV1BusinessPartnersResponses, GetV1CustomerByCustomerNumberData, GetV1CustomerByCustomerNumberErrors, GetV1CustomerByCustomerNumberResponses, GetV1CustomersData, GetV1CustomersErrors, GetV1CustomersResponses, GetV1IdentityCurrentMigrationCandidateBusinessPartnerByIdData, GetV1IdentityCurrentMigrationCandidateBusinessPartnerByIdErrors, GetV1IdentityCurrentMigrationCandidateBusinessPartnerByIdResponses, GetV1IdentityCurrentMigrationCandidateBusinessPartnersData, GetV1IdentityCurrentMigrationCandidateBusinessPartnersErrors, GetV1IdentityCurrentMigrationCandidateBusinessPartnersResponses, GetV1IdentityCurrentRequestBusinessPartnerByIdData, GetV1IdentityCurrentRequestBusinessPartnerByIdErrors, GetV1IdentityCurrentRequestBusinessPartnerByIdResponses, GetV1IdentityCurrentRequestBusinessPartnersData, GetV1IdentityCurrentRequestBusinessPartnersErrors, GetV1IdentityCurrentRequestBusinessPartnersResponses, GetV1MigrationCandidateBusinessPartnerByIdData, GetV1MigrationCandidateBusinessPartnerByIdErrors, GetV1MigrationCandidateBusinessPartnerByIdResponses, GetV1MigrationCandidateBusinessPartnersData, GetV1MigrationCandidateBusinessPartnersErrors, GetV1MigrationCandidateBusinessPartnersResponses, GetV1ProductLinesData, GetV1ProductLinesErrors, GetV1ProductLinesResponses, GetV1ProvidersData, GetV1ProvidersErrors, GetV1ProvidersResponses, GetV1RequestBusinessPartnerByIdData, GetV1RequestBusinessPartnerByIdErrors, GetV1RequestBusinessPartnerByIdResponses, GetV1RequestBusinessPartnerDivisionsData, GetV1RequestBusinessPartnerDivisionsErrors, GetV1RequestBusinessPartnerDivisionsResponses, GetV1RequestBusinessPartnerProxiesData, GetV1RequestBusinessPartnerProxiesErrors, GetV1RequestBusinessPartnerProxiesResponses, GetV1RequestChangeOwnershipByIdData, GetV1RequestChangeOwnershipByIdErrors, GetV1RequestChangeOwnershipByIdResponses, GetV1RolesCurrentData, GetV1RolesCurrentErrors, GetV1RolesCurrentResponses, GetV1ServiceAgreementByIdData, GetV1ServiceAgreementByIdErrors, GetV1ServiceAgreementByIdResponses, GetV1ServiceAgreementsWithCustomerData, GetV1ServiceAgreementsWithCustomerErrors, GetV1ServiceAgreementsWithCustomerResponses, GetV1ServiceAgreementsWithProviderData, GetV1ServiceAgreementsWithProviderErrors, GetV1ServiceAgreementsWithProviderResponses, PostV1AddressSuggestData, PostV1AddressSuggestErrors, PostV1AddressSuggestResponses, PostV1BusinessPartnerCurrentMigrationCandidateUserByIdAcceptData, PostV1BusinessPartnerCurrentMigrationCandidateUserByIdAcceptErrors, PostV1BusinessPartnerCurrentMigrationCandidateUserByIdAcceptResponses, PostV1BusinessPartnerCurrentMigrationCandidateUserByIdRejectData, PostV1BusinessPartnerCurrentMigrationCandidateUserByIdRejectErrors, PostV1BusinessPartnerCurrentMigrationCandidateUserByIdRejectResponses, PostV1BusinessPartnerCurrentRequestChangeOwnershipData, PostV1BusinessPartnerCurrentRequestChangeOwnershipErrors, PostV1BusinessPartnerCurrentRequestChangeOwnershipResponses, PostV1IdentityCurrentMigrationCandidateBusinessPartnerByIdAcceptData, PostV1IdentityCurrentMigrationCandidateBusinessPartnerByIdAcceptErrors, PostV1IdentityCurrentMigrationCandidateBusinessPartnerByIdAcceptResponses, PostV1IdentityCurrentMigrationCandidateBusinessPartnerByIdRejectData, PostV1IdentityCurrentMigrationCandidateBusinessPartnerByIdRejectErrors, PostV1IdentityCurrentMigrationCandidateBusinessPartnerByIdRejectResponses, PostV1IdentityCurrentRequestBusinessPartnerData, PostV1IdentityCurrentRequestBusinessPartnerErrors, PostV1IdentityCurrentRequestBusinessPartnerResponses, PostV1MigrationCandidateBusinessPartnerByIdAcceptData, PostV1MigrationCandidateBusinessPartnerByIdAcceptErrors, PostV1MigrationCandidateBusinessPartnerByIdAcceptResponses, PostV1MigrationCandidateBusinessPartnerByIdRejectData, PostV1MigrationCandidateBusinessPartnerByIdRejectErrors, PostV1MigrationCandidateBusinessPartnerByIdRejectResponses, PostV1RequestBusinessPartnerByIdAcceptData, PostV1RequestBusinessPartnerByIdAcceptErrors, PostV1RequestBusinessPartnerByIdAcceptResponses, PostV1RequestBusinessPartnerByIdDeclineData, PostV1RequestBusinessPartnerByIdDeclineErrors, PostV1RequestBusinessPartnerByIdDeclineResponses, PostV1RequestBusinessPartnerByIdRegistrationTokenData, PostV1RequestBusinessPartnerByIdRegistrationTokenErrors, PostV1RequestBusinessPartnerByIdRegistrationTokenResponses, PostV1RequestBusinessPartnerDivisionData, PostV1RequestBusinessPartnerDivisionErrors, PostV1RequestBusinessPartnerDivisionResponses, PostV1RequestBusinessPartnerProxyData, PostV1RequestBusinessPartnerProxyErrors, PostV1RequestBusinessPartnerProxyResponses, PostV1RequestChangeOwnershipByIdAcceptData, PostV1RequestChangeOwnershipByIdAcceptErrors, PostV1RequestChangeOwnershipByIdAcceptResponses, PostV1ServiceAgreementByIdAcceptData, PostV1ServiceAgreementByIdAcceptErrors, PostV1ServiceAgreementByIdAcceptResponses, PostV1ServiceAgreementByIdDeclineData, PostV1ServiceAgreementByIdDeclineErrors, PostV1ServiceAgreementByIdDeclineResponses, PostV1ServiceAgreementWithCustomerData, PostV1ServiceAgreementWithCustomerErrors, PostV1ServiceAgreementWithCustomerResponses, PostV1ServiceAgreementWithProviderData, PostV1ServiceAgreementWithProviderErrors, PostV1ServiceAgreementWithProviderResponses, PutV1BusinessPartnerCurrentChangeData, PutV1BusinessPartnerCurrentChangeErrors, PutV1BusinessPartnerCurrentChangeResponses, PutV1IdentityCurrentRequestBusinessPartnerByIdData, PutV1IdentityCurrentRequestBusinessPartnerByIdErrors, PutV1IdentityCurrentRequestBusinessPartnerByIdResponses, PutV1RequestBusinessPartnerByIdData, PutV1RequestBusinessPartnerByIdErrors, PutV1RequestBusinessPartnerByIdResponses, PutV1ServiceAgreementByIdData, PutV1ServiceAgreementByIdErrors, PutV1ServiceAgreementByIdResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Get a list of addresses from the address suggestion service
 *
 *  Get a list of addresses from the address suggestion service. <hr /> <br /> <br /> Must be authenticated. <br /> <br /> These values match business partner address, but are not required. <br /> If a lat/lng is available from a user geo lookup, supply that. <br /> If not supplied, lat/lng will default to the central US, unless a Country, StateProvinceRegion, or City is supplied. <br /> Prefer lat/lng, unless the user changes their country, from the geo lookup value.
 */
export const postV1AddressSuggest = <ThrowOnError extends boolean = false>(options: Options<PostV1AddressSuggestData, ThrowOnError>): RequestResult<PostV1AddressSuggestResponses, PostV1AddressSuggestErrors, ThrowOnError> => (options.client ?? client).post<PostV1AddressSuggestResponses, PostV1AddressSuggestErrors, ThrowOnError>({
    security: [{
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/address/suggest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get current business partner
 *
 *  Get the business partner for current token. <hr /> <br /> <br /> Requires bp_admin role, otherwise responds with HTTP status **403**.
 */
export const getV1BusinessPartnerCurrent = <ThrowOnError extends boolean = false>(options?: Options<GetV1BusinessPartnerCurrentData, ThrowOnError>): RequestResult<GetV1BusinessPartnerCurrentResponses, GetV1BusinessPartnerCurrentErrors, ThrowOnError> => (options?.client ?? client).get<GetV1BusinessPartnerCurrentResponses, GetV1BusinessPartnerCurrentErrors, ThrowOnError>({
    security: [{
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/businessPartner/current',
    ...options
});

/**
 * Delete change for current business partner
 *
 *  Deletes pending change request for current business partner. <hr /> <br /> <br /> Requires bp_admin role, otherwise responds with HTTP status **403**. <br /> If there is already a pending change with status `accepted`, responds with HTTP status **409**. <br /> If there is no current change request for current business partner, responds with HTTP status **404**.
 */
export const deleteV1BusinessPartnerCurrentChange = <ThrowOnError extends boolean = false>(options?: Options<DeleteV1BusinessPartnerCurrentChangeData, ThrowOnError>): RequestResult<DeleteV1BusinessPartnerCurrentChangeResponses, DeleteV1BusinessPartnerCurrentChangeErrors, ThrowOnError> => (options?.client ?? client).delete<DeleteV1BusinessPartnerCurrentChangeResponses, DeleteV1BusinessPartnerCurrentChangeErrors, ThrowOnError>({
    security: [{
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/businessPartner/current/change',
    ...options
});

/**
 * Get change request for current business partner
 *
 *  Get pending change details request for current business partner. <hr /> <br /> <br /> Requires bp_admin role, otherwise responds with HTTP status **403**. <br /> If no pending change exists, responds with HTTP status **404**. <br /> <br /> If responds with HTTP status **200**, the change request is either `pending` or `accepted`. <br /> <br /> An `accepted` change request will promptly be applied to current business partner and then deleted.
 */
export const getV1BusinessPartnerCurrentChange = <ThrowOnError extends boolean = false>(options?: Options<GetV1BusinessPartnerCurrentChangeData, ThrowOnError>): RequestResult<GetV1BusinessPartnerCurrentChangeResponses, GetV1BusinessPartnerCurrentChangeErrors, ThrowOnError> => (options?.client ?? client).get<GetV1BusinessPartnerCurrentChangeResponses, GetV1BusinessPartnerCurrentChangeErrors, ThrowOnError>({
    security: [{
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/businessPartner/current/change',
    ...options
});

/**
 * Put change request for current business partner
 *
 *  Upsert a request to change details about current business partner. <hr /> <br /> <br /> Requires bp_admin role, otherwise responds with HTTP status **403**. <br /> If there is already a pending change being applied, responds with HTTP status **409**. <br /> <br /> On success, responds with HTTP status **202** and the change request is either `pending` or `accepted`. <br /> <br /> An `accepted` change request will promptly be applied to current business partner and then deleted. A `pending` is due to potential duplicates and will be reviewed by Topcon. <br /> <br /> Notifications will be generated informing progress of the change request.
 */
export const putV1BusinessPartnerCurrentChange = <ThrowOnError extends boolean = false>(options: Options<PutV1BusinessPartnerCurrentChangeData, ThrowOnError>): RequestResult<PutV1BusinessPartnerCurrentChangeResponses, PutV1BusinessPartnerCurrentChangeErrors, ThrowOnError> => (options.client ?? client).put<PutV1BusinessPartnerCurrentChangeResponses, PutV1BusinessPartnerCurrentChangeErrors, ThrowOnError>({
    security: [{
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/businessPartner/current/change',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List divisions of current business partner
 *
 *  List all divisions of current business partner. <hr /> <br /> <br /> Requires bp_admin role, otherwise responds with HTTP status **403**. <br /> If current business partner type isn't `topcon`, `dealer` or `end_customer_enterprise`, responds with HTTP status **403**.
 */
export const getV1BusinessPartnerCurrentDivisions = <ThrowOnError extends boolean = false>(options?: Options<GetV1BusinessPartnerCurrentDivisionsData, ThrowOnError>): RequestResult<GetV1BusinessPartnerCurrentDivisionsResponses, GetV1BusinessPartnerCurrentDivisionsErrors, ThrowOnError> => (options?.client ?? client).get<GetV1BusinessPartnerCurrentDivisionsResponses, GetV1BusinessPartnerCurrentDivisionsErrors, ThrowOnError>({
    security: [{
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/businessPartner/current/divisions',
    ...options
});

/**
 * Get migration candidate user
 *
 *  Get a specific migration candidate user. <hr /> <br /> <br /> Must have `bp_admin` role. <br /> If current business partner doesn't resolve, responds with HTTP status **403**. <br /> If the id is not a UUID, responds with HTTP status **400**. <br /> If the migration candidate user is not pending, doesn't exist, is not for the current business partner, or its business partner candidate is not matched or accepted, responds with HTTP status **404**.
 */
export const getV1BusinessPartnerCurrentMigrationCandidateUserById = <ThrowOnError extends boolean = false>(options: Options<GetV1BusinessPartnerCurrentMigrationCandidateUserByIdData, ThrowOnError>): RequestResult<GetV1BusinessPartnerCurrentMigrationCandidateUserByIdResponses, GetV1BusinessPartnerCurrentMigrationCandidateUserByIdErrors, ThrowOnError> => (options.client ?? client).get<GetV1BusinessPartnerCurrentMigrationCandidateUserByIdResponses, GetV1BusinessPartnerCurrentMigrationCandidateUserByIdErrors, ThrowOnError>({
    security: [{
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/businessPartner/current/migrationCandidateUser/{id}',
    ...options
});

/**
 * Accept migration candidate user
 *
 *  Accept a migration candidate user. <hr /> <br /> <br /> Must have `bp_admin` role. <br /> If current business partner doesn't resolve, responds with HTTP status **403**. <br /> If the id is not a UUID, responds with HTTP status **400**. <br /> If the migration candidate user is not pending, doesn't exist, is not for the current business partner, or its business partner candidate is not matched or accepted, responds with HTTP status **404**. <br /> On success, responds with HTTP status **204**. The migration candidate user status transitions to 'accepted'. <br /> After the status transition, Directus best-effort processing creates a user when an identity with the canonical email exists, or an invite to join otherwise. An existing user or invite for the business partner satisfies this processing.
 */
export const postV1BusinessPartnerCurrentMigrationCandidateUserByIdAccept = <ThrowOnError extends boolean = false>(options: Options<PostV1BusinessPartnerCurrentMigrationCandidateUserByIdAcceptData, ThrowOnError>): RequestResult<PostV1BusinessPartnerCurrentMigrationCandidateUserByIdAcceptResponses, PostV1BusinessPartnerCurrentMigrationCandidateUserByIdAcceptErrors, ThrowOnError> => (options.client ?? client).post<PostV1BusinessPartnerCurrentMigrationCandidateUserByIdAcceptResponses, PostV1BusinessPartnerCurrentMigrationCandidateUserByIdAcceptErrors, ThrowOnError>({
    security: [{
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/businessPartner/current/migrationCandidateUser/{id}/accept',
    ...options
});

/**
 * Reject migration candidate user
 *
 *  Reject a migration candidate user. <hr /> <br /> <br /> Must have `bp_admin` role. <br /> If current business partner doesn't resolve, responds with HTTP status **403**. <br /> If the id is not a UUID, responds with HTTP status **400**. <br /> If the migration candidate user is not pending, doesn't exist, is not for the current business partner, or its business partner candidate is not matched or accepted, responds with HTTP status **404**. <br /> On success, responds with HTTP status **204**. The migration candidate user status transitions to 'rejected'. No user or invite is created.
 */
export const postV1BusinessPartnerCurrentMigrationCandidateUserByIdReject = <ThrowOnError extends boolean = false>(options: Options<PostV1BusinessPartnerCurrentMigrationCandidateUserByIdRejectData, ThrowOnError>): RequestResult<PostV1BusinessPartnerCurrentMigrationCandidateUserByIdRejectResponses, PostV1BusinessPartnerCurrentMigrationCandidateUserByIdRejectErrors, ThrowOnError> => (options.client ?? client).post<PostV1BusinessPartnerCurrentMigrationCandidateUserByIdRejectResponses, PostV1BusinessPartnerCurrentMigrationCandidateUserByIdRejectErrors, ThrowOnError>({
    security: [{
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/businessPartner/current/migrationCandidateUser/{id}/reject',
    ...options
});

/**
 * List migration candidate users
 *
 *  List migration candidate users requiring action for current business partner. <hr /> <br /> <br /> Migration candidate users represent suggested users to be added to the business partner from external system imports. Returns pending user candidates for migration candidate business partners that are matched or accepted and linked to the current business partner. Accepted and rejected user candidates, and users whose business partner candidate is not actionable, are excluded and retained for audit. <br /> <br /> Must have `bp_admin` role. <br /> If current business partner doesn't resolve, responds with HTTP status **403**.
 */
export const getV1BusinessPartnerCurrentMigrationCandidateUsers = <ThrowOnError extends boolean = false>(options?: Options<GetV1BusinessPartnerCurrentMigrationCandidateUsersData, ThrowOnError>): RequestResult<GetV1BusinessPartnerCurrentMigrationCandidateUsersResponses, GetV1BusinessPartnerCurrentMigrationCandidateUsersErrors, ThrowOnError> => (options?.client ?? client).get<GetV1BusinessPartnerCurrentMigrationCandidateUsersResponses, GetV1BusinessPartnerCurrentMigrationCandidateUsersErrors, ThrowOnError>({
    security: [{
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/businessPartner/current/migrationCandidateUsers',
    ...options
});

/**
 * Cancels the current change ownership request for the current business partner
 *
 *  Cancels the current change ownership request for the current business partner <br /> Requires bp_owner role, otherwise response with HTTP status 403 <br /> If there is no current request to change ownership, responds with HTTP status **404**
 */
export const deleteV1BusinessPartnerCurrentRequestChangeOwnership = <ThrowOnError extends boolean = false>(options?: Options<DeleteV1BusinessPartnerCurrentRequestChangeOwnershipData, ThrowOnError>): RequestResult<DeleteV1BusinessPartnerCurrentRequestChangeOwnershipResponses, DeleteV1BusinessPartnerCurrentRequestChangeOwnershipErrors, ThrowOnError> => (options?.client ?? client).delete<DeleteV1BusinessPartnerCurrentRequestChangeOwnershipResponses, DeleteV1BusinessPartnerCurrentRequestChangeOwnershipErrors, ThrowOnError>({
    security: [{
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/businessPartner/current/requestChangeOwnership',
    ...options
});

/**
 * Get the current change ownership request for the current business partner
 *
 *  Get the current change ownership request for the current business partner <br /> Requires bp_owner role, otherwise responds with HTTP status **403** <br /> If there is no current request to change ownership, responds with HTTP status **404** <br /> There can only be one change ownership request per business partner <br /> If the current business partner is of type Topcon or Dealer, responds with HTTP status **409**
 */
export const getV1BusinessPartnerCurrentRequestChangeOwnership = <ThrowOnError extends boolean = false>(options?: Options<GetV1BusinessPartnerCurrentRequestChangeOwnershipData, ThrowOnError>): RequestResult<GetV1BusinessPartnerCurrentRequestChangeOwnershipResponses, GetV1BusinessPartnerCurrentRequestChangeOwnershipErrors, ThrowOnError> => (options?.client ?? client).get<GetV1BusinessPartnerCurrentRequestChangeOwnershipResponses, GetV1BusinessPartnerCurrentRequestChangeOwnershipErrors, ThrowOnError>({
    security: [{
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/businessPartner/current/requestChangeOwnership',
    ...options
});

/**
 * Create an ownership request for the current business partner
 *
 *  Create a change ownership request for the current business partner <br /> Requires bp_owner role, otherwise response with HTTP status 403 <br /> If there is a current request to change ownership, responds with HTTP status **409** <br /> If the email specified is already an owner of a business partner, or a pending request business partner, responds with HTTP status 409 <br> If the current business partner is of type Topcon or Dealer, responds with HTTP status **409**
 */
export const postV1BusinessPartnerCurrentRequestChangeOwnership = <ThrowOnError extends boolean = false>(options: Options<PostV1BusinessPartnerCurrentRequestChangeOwnershipData, ThrowOnError>): RequestResult<PostV1BusinessPartnerCurrentRequestChangeOwnershipResponses, PostV1BusinessPartnerCurrentRequestChangeOwnershipErrors, ThrowOnError> => (options.client ?? client).post<PostV1BusinessPartnerCurrentRequestChangeOwnershipResponses, PostV1BusinessPartnerCurrentRequestChangeOwnershipErrors, ThrowOnError>({
    security: [{
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/businessPartner/current/requestChangeOwnership',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get business partners
 *
 *  Get business partners. <hr />
 */
export const getV1BusinessPartners = <ThrowOnError extends boolean = false>(options?: Options<GetV1BusinessPartnersData, ThrowOnError>): RequestResult<GetV1BusinessPartnersResponses, GetV1BusinessPartnersErrors, ThrowOnError> => (options?.client ?? client).get<GetV1BusinessPartnersResponses, GetV1BusinessPartnersErrors, ThrowOnError>({
    security: [{
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/businessPartners',
    ...options
});

/**
 * Get customer
 *
 *  Get customer by 12-digit customer number. <hr /> Requires bp_admin role, otherwise responds with HTTP status **403**. <br /> If current business partner doesn't resolve, responds with HTTP status **403**. <br /> If current business partner type isn't `dealer`, responds with HTTP status **403**.
 */
export const getV1CustomerByCustomerNumber = <ThrowOnError extends boolean = false>(options: Options<GetV1CustomerByCustomerNumberData, ThrowOnError>): RequestResult<GetV1CustomerByCustomerNumberResponses, GetV1CustomerByCustomerNumberErrors, ThrowOnError> => (options.client ?? client).get<GetV1CustomerByCustomerNumberResponses, GetV1CustomerByCustomerNumberErrors, ThrowOnError>({
    security: [{
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/customer/{customerNumber}',
    ...options
});

/**
 * Get customers
 *
 *  Get customers. Deprecated, use "/v1/customer/{customerNumber}". <hr /> <br /> <br /> For any results, provide at least first 5 characters including whitespace to the name filter. <br /> <br /> Requires bp_admin role, otherwise responds with HTTP status **403**. <br /> If current business partner doesn't resolve, responds with HTTP status **403**. <br /> If current business partner type isn't `dealer`, responds with HTTP status **403**.
 *
 * @deprecated
 */
export const getV1Customers = <ThrowOnError extends boolean = false>(options?: Options<GetV1CustomersData, ThrowOnError>): RequestResult<GetV1CustomersResponses, GetV1CustomersErrors, ThrowOnError> => (options?.client ?? client).get<GetV1CustomersResponses, GetV1CustomersErrors, ThrowOnError>({
    security: [{
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/customers',
    ...options
});

/**
 * Get migration candidate business partner
 *
 *  Get a specific migration candidate business partner. <hr /> <br /> <br /> If authorization token is not for identity only (switch=nobp), responds with HTTP status **403**. <br /> If the migration candidate doesn't exist or current identity's canonical email doesn't match a migration_candidate_user for this candidate, responds with HTTP status **404**.
 */
export const getV1IdentityCurrentMigrationCandidateBusinessPartnerById = <ThrowOnError extends boolean = false>(options: Options<GetV1IdentityCurrentMigrationCandidateBusinessPartnerByIdData, ThrowOnError>): RequestResult<GetV1IdentityCurrentMigrationCandidateBusinessPartnerByIdResponses, GetV1IdentityCurrentMigrationCandidateBusinessPartnerByIdErrors, ThrowOnError> => (options.client ?? client).get<GetV1IdentityCurrentMigrationCandidateBusinessPartnerByIdResponses, GetV1IdentityCurrentMigrationCandidateBusinessPartnerByIdErrors, ThrowOnError>({
    security: [{
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/identity/current/migrationCandidateBusinessPartner/{id}',
    ...options
});

/**
 * Accept (match) migration candidate business partner
 *
 *  Accept (match) a pending migration candidate business partner for the current identity. <hr /> <br /> Links the candidate to an existing business partner identified by `externalId` (a Topcon Resource Name / ext_id), sets `status` to `accepted`, and computes `service_agreement_status`: `accepted` if a service agreement already exists between the candidate's dealer (provider) and the linked business partner (customer), otherwise `pending` (the FE should then guide the user through a service agreement creation flow). <br /> <br /> Creates neither a Request Business Partner nor a Service Agreement. Operates on pending candidates only; call this endpoint to make a matching decision the import tool was not confident enough to make automatically. <br /> <br /> The `externalId` must identify a business partner that is either listed in the candidate's `matchDetails.top_targets` OR is a business partner the current identity owns or is a user member of. <br /> <br /> If authorization token is not for identity only (switch=nobp), responds with HTTP status **403**. <br /> If the migration candidate doesn't exist, the current identity doesn't match a migration_candidate_user for this candidate, or the candidate is not pending, responds with HTTP status **404**. <br /> If `externalId` is missing or empty, or `externalId` is not one of the candidate's `top_targets` (and the identity-ownership path also fails), responds with HTTP status **400** or **409** respectively. <br /> If the business partner identified by `externalId` does not exist, responds with HTTP status **409**. <br /> <br /> On success, responds with HTTP status **200** with the updated migration candidate body including the new `status`, `businessPartner`, and `serviceAgreementStatus`.
 */
export const postV1IdentityCurrentMigrationCandidateBusinessPartnerByIdAccept = <ThrowOnError extends boolean = false>(options: Options<PostV1IdentityCurrentMigrationCandidateBusinessPartnerByIdAcceptData, ThrowOnError>): RequestResult<PostV1IdentityCurrentMigrationCandidateBusinessPartnerByIdAcceptResponses, PostV1IdentityCurrentMigrationCandidateBusinessPartnerByIdAcceptErrors, ThrowOnError> => (options.client ?? client).post<PostV1IdentityCurrentMigrationCandidateBusinessPartnerByIdAcceptResponses, PostV1IdentityCurrentMigrationCandidateBusinessPartnerByIdAcceptErrors, ThrowOnError>({
    security: [{
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/identity/current/migrationCandidateBusinessPartner/{id}/accept',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reject migration candidate business partner
 *
 *  Reject a migration candidate business partner. <hr /> <br /> <br /> If authorization token is not for identity only (switch=nobp), responds with HTTP status **403**. <br /> If the migration candidate doesn't exist, current identity's canonical email doesn't match a migration_candidate_user for this candidate, or the candidate is neither pending nor matched with a pending service agreement, responds with HTTP status **404**. <br /> <br /> On success, responds with HTTP status **204**. A pending candidate's status transitions to 'rejected'. A candidate matched to a business partner but awaiting service agreement acceptance (status is 'matched' and service_agreement_status is 'pending') instead has its service_agreement_status transitioned to 'rejected', leaving status as 'matched'.
 */
export const postV1IdentityCurrentMigrationCandidateBusinessPartnerByIdReject = <ThrowOnError extends boolean = false>(options: Options<PostV1IdentityCurrentMigrationCandidateBusinessPartnerByIdRejectData, ThrowOnError>): RequestResult<PostV1IdentityCurrentMigrationCandidateBusinessPartnerByIdRejectResponses, PostV1IdentityCurrentMigrationCandidateBusinessPartnerByIdRejectErrors, ThrowOnError> => (options.client ?? client).post<PostV1IdentityCurrentMigrationCandidateBusinessPartnerByIdRejectResponses, PostV1IdentityCurrentMigrationCandidateBusinessPartnerByIdRejectErrors, ThrowOnError>({
    security: [{
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/identity/current/migrationCandidateBusinessPartner/{id}/reject',
    ...options
});

/**
 * List migration candidate business partners
 *
 *  List migration candidate business partners for current identity. <hr /> <br /> <br /> Migration candidates represent data imported from external systems. This endpoint returns only pending candidates (status = "pending") where the identity's canonical email matches a migration_candidate_user. This indicates the identity was an admin in the source system for this business partner. Accepted and rejected candidates are excluded (kept for audit and garbage collection). <br /> <br /> If authorization token is not for identity only (switch=nobp), responds with HTTP status **403**.
 */
export const getV1IdentityCurrentMigrationCandidateBusinessPartners = <ThrowOnError extends boolean = false>(options?: Options<GetV1IdentityCurrentMigrationCandidateBusinessPartnersData, ThrowOnError>): RequestResult<GetV1IdentityCurrentMigrationCandidateBusinessPartnersResponses, GetV1IdentityCurrentMigrationCandidateBusinessPartnersErrors, ThrowOnError> => (options?.client ?? client).get<GetV1IdentityCurrentMigrationCandidateBusinessPartnersResponses, GetV1IdentityCurrentMigrationCandidateBusinessPartnersErrors, ThrowOnError>({
    security: [{
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/identity/current/migrationCandidateBusinessPartners',
    ...options
});

/**
 * Create a business partner request for your identity
 *
 *  Create a request for a new business partner of a customer type for current identity. <hr /> <br /> <br /> If authorization token is not for identity only (switch=nobp), responds with HTTP status **403**. <br /> If current identity owns 3 or more root business partner already, responds with HTTP status **409**. <br /> If the stated service provider type is not `dealer`, responds with HTTP status **409**. <br /> <br /> On success, responds with HTTP status **201** and the business partner request is `accepted`. <br /> <br /> Notifications will be generated informing progress of the business partner request for the service provider and identity. <br /> <br /> A business partner request with status `accepted` will promptly change status to `done` and a new business partner and service agreement with the service provider will be created. The new service agreement will require consent from the service provider. <br /> <br /> A business partner request with status `rejected` will remain until deleted by the identity or garbage collected. Requests are rejected if they appear to be duplicates. Rejected requests may be updated with new details to try again. <br /> <br /> Optionally supply `migrationCandidateBusinessPartnerId` to accept a migration candidate business partner. When supplied, the new business partner request is linked to that candidate and the candidate is accepted as a side effect. Omit it for an ordinary self-service request.
 */
export const postV1IdentityCurrentRequestBusinessPartner = <ThrowOnError extends boolean = false>(options: Options<PostV1IdentityCurrentRequestBusinessPartnerData, ThrowOnError>): RequestResult<PostV1IdentityCurrentRequestBusinessPartnerResponses, PostV1IdentityCurrentRequestBusinessPartnerErrors, ThrowOnError> => (options.client ?? client).post<PostV1IdentityCurrentRequestBusinessPartnerResponses, PostV1IdentityCurrentRequestBusinessPartnerErrors, ThrowOnError>({
    security: [{
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/identity/current/requestBusinessPartner',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete own particular business partner request
 *
 *  Delete a business partner request owned by current identity. <hr /> <br /> <br /> If authorization token is not for identity only (switch=nobp), responds with HTTP status **403**. <br /> If the business partner request doesn't exist or current identity is not the owner, responds with HTTP status **404**. <br /> If the business partner request status is not `rejected`, `done` or `closed`, responds with HTTP status 409. <br /> (you can't delete a request while it is being processed).
 */
export const deleteV1IdentityCurrentRequestBusinessPartnerById = <ThrowOnError extends boolean = false>(options: Options<DeleteV1IdentityCurrentRequestBusinessPartnerByIdData, ThrowOnError>): RequestResult<DeleteV1IdentityCurrentRequestBusinessPartnerByIdResponses, DeleteV1IdentityCurrentRequestBusinessPartnerByIdErrors, ThrowOnError> => (options.client ?? client).delete<DeleteV1IdentityCurrentRequestBusinessPartnerByIdResponses, DeleteV1IdentityCurrentRequestBusinessPartnerByIdErrors, ThrowOnError>({
    security: [{
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/identity/current/requestBusinessPartner/{id}',
    ...options
});

/**
 * Get own particular business partner request
 *
 *  Get a business partner request owned by current identity. <hr /> <br /> <br /> If authorization token is not for identity only (switch=nobp), responds with HTTP status **403**. <br /> If the business partner request doesn't exist or current identity is not the owner, responds with HTTP status **404**.
 */
export const getV1IdentityCurrentRequestBusinessPartnerById = <ThrowOnError extends boolean = false>(options: Options<GetV1IdentityCurrentRequestBusinessPartnerByIdData, ThrowOnError>): RequestResult<GetV1IdentityCurrentRequestBusinessPartnerByIdResponses, GetV1IdentityCurrentRequestBusinessPartnerByIdErrors, ThrowOnError> => (options.client ?? client).get<GetV1IdentityCurrentRequestBusinessPartnerByIdResponses, GetV1IdentityCurrentRequestBusinessPartnerByIdErrors, ThrowOnError>({
    security: [{
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/identity/current/requestBusinessPartner/{id}',
    ...options
});

/**
 * Update own particular business partner request
 *
 *  Update a business partner request owned by current identity. <hr /> <br /> <br /> If authorization token is not for identity only (switch=nobp), responds with HTTP status **403**. <br /> If the business partner request doesn't exist or current identity is not the owner, responds with HTTP status **404**. <br /> If the business partner request status is not `rejected` or `customer_review`, responds with HTTP status **409**. <br /> <br /> On success, if business partner request was `rejected`, responds with HTTP status **202** and the status is `accepted` and the request is in progress again.
 */
export const putV1IdentityCurrentRequestBusinessPartnerById = <ThrowOnError extends boolean = false>(options: Options<PutV1IdentityCurrentRequestBusinessPartnerByIdData, ThrowOnError>): RequestResult<PutV1IdentityCurrentRequestBusinessPartnerByIdResponses, PutV1IdentityCurrentRequestBusinessPartnerByIdErrors, ThrowOnError> => (options.client ?? client).put<PutV1IdentityCurrentRequestBusinessPartnerByIdResponses, PutV1IdentityCurrentRequestBusinessPartnerByIdErrors, ThrowOnError>({
    security: [{
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/identity/current/requestBusinessPartner/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List own business partner requests
 *
 *  List all business partner requests owned by current identity. <hr /> <br /> <br /> If authorization token is not for identity only (switch=nobp), responds with HTTP status **403**.
 */
export const getV1IdentityCurrentRequestBusinessPartners = <ThrowOnError extends boolean = false>(options?: Options<GetV1IdentityCurrentRequestBusinessPartnersData, ThrowOnError>): RequestResult<GetV1IdentityCurrentRequestBusinessPartnersResponses, GetV1IdentityCurrentRequestBusinessPartnersErrors, ThrowOnError> => (options?.client ?? client).get<GetV1IdentityCurrentRequestBusinessPartnersResponses, GetV1IdentityCurrentRequestBusinessPartnersErrors, ThrowOnError>({
    security: [{
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/identity/current/requestBusinessPartners',
    ...options
});

/**
 * Get migration candidate business partner
 *
 *  Get a specific migration candidate business partner for the current dealer business partner. <hr /> <br /> <br /> Only candidates that still require dealer action are returned: either the candidate itself is pending (status = "pending"), or the candidate has been accepted/matched to a business partner but its service agreement is still pending (status in ["accepted", "matched"] and service_agreement_status = "pending"). <br /> <br /> Must have `sa_customer_admin` role. <br /> If current business partner doesn't resolve, responds with HTTP status **403**. <br /> If current business partner type isn't `dealer`, responds with HTTP status **403**. <br /> If the migration candidate doesn't exist, the dealer_business_partner_id doesn't match current business partner, or the candidate no longer requires dealer action (not pending and not accepted/matched with a pending service agreement), responds with HTTP status **404**.
 */
export const getV1MigrationCandidateBusinessPartnerById = <ThrowOnError extends boolean = false>(options: Options<GetV1MigrationCandidateBusinessPartnerByIdData, ThrowOnError>): RequestResult<GetV1MigrationCandidateBusinessPartnerByIdResponses, GetV1MigrationCandidateBusinessPartnerByIdErrors, ThrowOnError> => (options.client ?? client).get<GetV1MigrationCandidateBusinessPartnerByIdResponses, GetV1MigrationCandidateBusinessPartnerByIdErrors, ThrowOnError>({
    security: [{
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/migrationCandidateBusinessPartner/{id}',
    ...options
});

/**
 * Accept (match) migration candidate as dealer
 *
 *  Accept (match) a pending migration candidate business partner as the dealer. <hr /> <br /> Links the candidate to an existing business partner identified by `externalId` (a Topcon Resource Name / ext_id), sets `status` to `accepted`, and computes `service_agreement_status`: `accepted` if a service agreement already exists between the current dealer (provider) and the linked business partner (customer), otherwise `pending` (the FE should then guide the user through a service agreement creation flow). <br /> <br /> Creates neither a Request Business Partner nor a Service Agreement. Operates on pending candidates only; returns **409** if the candidate is not pending (e.g. already matched by the import tool). <br /> <br /> The `externalId` must be one of the candidate's `matchDetails.top_targets`. <br /> <br /> Must have `sa_customer_admin` role. <br /> If current business partner doesn't resolve, responds with HTTP status **403**. <br /> If current business partner type isn't `dealer`, responds with HTTP status **403**. <br /> If the migration candidate doesn't exist or the dealer_business_partner_id doesn't match the current business partner, responds with HTTP status **404**. <br /> If `externalId` is missing or empty, or `externalId` is not one of the candidate's `top_targets`, responds with HTTP status **400**. <br /> If the candidate is not pending, or the business partner identified by `externalId` does not exist, responds with HTTP status **409**. <br /> <br /> On success, responds with HTTP status **200** with the updated migration candidate body including the new `status`, `businessPartner`, and `serviceAgreementStatus`.
 */
export const postV1MigrationCandidateBusinessPartnerByIdAccept = <ThrowOnError extends boolean = false>(options: Options<PostV1MigrationCandidateBusinessPartnerByIdAcceptData, ThrowOnError>): RequestResult<PostV1MigrationCandidateBusinessPartnerByIdAcceptResponses, PostV1MigrationCandidateBusinessPartnerByIdAcceptErrors, ThrowOnError> => (options.client ?? client).post<PostV1MigrationCandidateBusinessPartnerByIdAcceptResponses, PostV1MigrationCandidateBusinessPartnerByIdAcceptErrors, ThrowOnError>({
    security: [{
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/migrationCandidateBusinessPartner/{id}/accept',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reject migration candidate as dealer
 *
 *  Reject a migration candidate business partner as the dealer. <hr /> <br /> <br /> Must have `sa_customer_admin` role. <br /> If current business partner doesn't resolve, responds with HTTP status **403**. <br /> If current business partner type isn't `dealer`, responds with HTTP status **403**. <br /> If the migration candidate doesn't exist, the dealer_business_partner_id doesn't match current business partner, or the candidate is neither pending nor matched with a pending service agreement, responds with HTTP status **404**. <br /> <br /> On success, responds with HTTP status **204**. A pending candidate's status transitions to 'rejected'. A candidate matched to a business partner but awaiting service agreement acceptance (status is 'matched' and service_agreement_status is 'pending') instead has its service_agreement_status transitioned to 'rejected', leaving status as 'matched'.
 */
export const postV1MigrationCandidateBusinessPartnerByIdReject = <ThrowOnError extends boolean = false>(options: Options<PostV1MigrationCandidateBusinessPartnerByIdRejectData, ThrowOnError>): RequestResult<PostV1MigrationCandidateBusinessPartnerByIdRejectResponses, PostV1MigrationCandidateBusinessPartnerByIdRejectErrors, ThrowOnError> => (options.client ?? client).post<PostV1MigrationCandidateBusinessPartnerByIdRejectResponses, PostV1MigrationCandidateBusinessPartnerByIdRejectErrors, ThrowOnError>({
    security: [{
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/migrationCandidateBusinessPartner/{id}/reject',
    ...options
});

/**
 * List migration candidates for dealer
 *
 *  List migration candidate business partners for current dealer business partner. <hr /> <br /> <br /> Returns migration candidates where the dealer_business_partner_id matches the current business partner. Returns candidates that still require dealer action: either the candidate itself is pending (status = "pending"), or the candidate has been accepted/matched to a business partner but its service agreement is still pending (status in ["accepted", "matched"] and service_agreement_status = "pending"). Candidates that are fully accepted/rejected with no pending service agreement are excluded (kept for audit and garbage collection). <br /> <br /> Must have `sa_customer_admin` role. <br /> If current business partner doesn't resolve, responds with HTTP status **403**. <br /> If current business partner type isn't `dealer`, responds with HTTP status **403**.
 */
export const getV1MigrationCandidateBusinessPartners = <ThrowOnError extends boolean = false>(options?: Options<GetV1MigrationCandidateBusinessPartnersData, ThrowOnError>): RequestResult<GetV1MigrationCandidateBusinessPartnersResponses, GetV1MigrationCandidateBusinessPartnersErrors, ThrowOnError> => (options?.client ?? client).get<GetV1MigrationCandidateBusinessPartnersResponses, GetV1MigrationCandidateBusinessPartnersErrors, ThrowOnError>({
    security: [{
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/migrationCandidateBusinessPartners',
    ...options
});

/**
 * Get product lines
 *
 *  Get product lines. <hr />
 */
export const getV1ProductLines = <ThrowOnError extends boolean = false>(options?: Options<GetV1ProductLinesData, ThrowOnError>): RequestResult<GetV1ProductLinesResponses, GetV1ProductLinesErrors, ThrowOnError> => (options?.client ?? client).get<GetV1ProductLinesResponses, GetV1ProductLinesErrors, ThrowOnError>({
    security: [{
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/productLines',
    ...options
});

/**
 * Get service providers
 *
 *  Get service providers. <hr />
 */
export const getV1Providers = <ThrowOnError extends boolean = false>(options?: Options<GetV1ProvidersData, ThrowOnError>): RequestResult<GetV1ProvidersResponses, GetV1ProvidersErrors, ThrowOnError> => (options?.client ?? client).get<GetV1ProvidersResponses, GetV1ProvidersErrors, ThrowOnError>({
    security: [{
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/providers',
    ...options
});

/**
 * Create request for a new division
 *
 *  Create a request for a new business partner as a division of current business partner and owner being current identity. <hr /> <br /> <br /> Requires bp_admin role, otherwise responds with HTTP status **403**. <br /> If current business partner doesn't resolve, responds with HTTP status **403**. <br /> If current business partner type isn't in the set `end_customer_enterprise`, responds with HTTP status **403**. <br /> If there are 10 or more existing business partner requests, responds with HTTP status **409**. <br /> If there are 100 or more existing divisions, responds with HTTP status **409**. <br /> If the stated service provider type is not `dealer`, responds with HTTP status **409**. <br /> <br /> On success, responds with HTTP status **202** and the business partner request is `accepted`. <br /> <br /> Notifications will be generated informing progress of the change request for the service provider and current identity. <br /> <br /> A business partner request with status `accepted` will promptly change status to `done` and a new business partner and service agreement with the service provider will be created. <br /> <br /> The new service agreement will require consent from the service provider. <br /> <br /> The new business partner will be a division of current business partner, and owned by current identity. <br /> <br /> A request with status `rejected` will remain until deleted by the identity or garbage collected. Requests are rejected if they appear to be duplicates. Rejected requests may be updated with new details to try again.
 */
export const postV1RequestBusinessPartnerDivision = <ThrowOnError extends boolean = false>(options: Options<PostV1RequestBusinessPartnerDivisionData, ThrowOnError>): RequestResult<PostV1RequestBusinessPartnerDivisionResponses, PostV1RequestBusinessPartnerDivisionErrors, ThrowOnError> => (options.client ?? client).post<PostV1RequestBusinessPartnerDivisionResponses, PostV1RequestBusinessPartnerDivisionErrors, ThrowOnError>({
    security: [{
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/requestBusinessPartner/division',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List the business partner requests for new divisions
 *
 *  Get the division business partner requests of current business partner. <hr /> <br /> <br /> Requires bp_admin role, otherwise responds with HTTP status **403**. <br /> If current business partner doesn't resolve, responds with HTTP status **403**. <br /> If current business partner type isn't `end_customer_enterprise`, responds with HTTP status **403**.
 */
export const getV1RequestBusinessPartnerDivisions = <ThrowOnError extends boolean = false>(options?: Options<GetV1RequestBusinessPartnerDivisionsData, ThrowOnError>): RequestResult<GetV1RequestBusinessPartnerDivisionsResponses, GetV1RequestBusinessPartnerDivisionsErrors, ThrowOnError> => (options?.client ?? client).get<GetV1RequestBusinessPartnerDivisionsResponses, GetV1RequestBusinessPartnerDivisionsErrors, ThrowOnError>({
    security: [{
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/requestBusinessPartner/divisions',
    ...options
});

/**
 * List the business partner requests for new customers
 *
 *  Get the business partner request on behalf of customers (proxy requests). <hr /> <br /> <br /> Requires sa_customer_admin role, otherwise responds with HTTP status **403**. <br /> If current business partner doesn't resolve, responds with HTTP status **403**. <br /> If current business partner type isn't `dealer`, responds with HTTP status **403**.
 */
export const getV1RequestBusinessPartnerProxies = <ThrowOnError extends boolean = false>(options?: Options<GetV1RequestBusinessPartnerProxiesData, ThrowOnError>): RequestResult<GetV1RequestBusinessPartnerProxiesResponses, GetV1RequestBusinessPartnerProxiesErrors, ThrowOnError> => (options?.client ?? client).get<GetV1RequestBusinessPartnerProxiesResponses, GetV1RequestBusinessPartnerProxiesErrors, ThrowOnError>({
    security: [{
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/requestBusinessPartner/proxies',
    ...options
});

/**
 * Create request on behalf of a customer
 *
 *  Provider creates a request for a new business partner on behalf of of a customer. <hr /> <br /> <br /> Requires sa_customer_admin role, otherwise responds with HTTP status **403**. <br /> If current business partner doesn't resolve, responds with HTTP status **403**. <br /> If current business partner type isn't `dealer`, responds with HTTP status **403**. <br /> If the business partner request customer type isn't `end_customer_enterprise` or `end_customer_individual`, responds with HTTP status **400**. <br /> If the customer email identity already owns a business partner, responds with HTTP status **409**. <br /> If there is already a business partner request for the customer email identity, responds with HTTP status **409**. <br /> <br /> On success, if the business partner request is `customer_review`, responds with HTTP status **201**. On success, if the business partner request is `pending` or `accepted`, responds with HTTP status **202**. <br /> <br /> Notifications will be generated informing progress of the change request for the service provider support roles and the customer email identity. <br /> <br /> A request with status `accepted` will promptly change status to `done` and a new business partner and service agreement with the customer business partner will be created. <br /> <br /> The new service agreement will require consent from the customer email identity. <br /> <br /> A request with status `rejected` will remain until deleted or garbage collected. Requests are rejected if they appear to be duplicates. Rejected requests may be updated with new details to try again. <br /> <br /> Optionally supply `migrationCandidateBusinessPartnerId` to accept a migration candidate business partner on the customer's behalf. When supplied, the new business partner request is linked to that candidate and the candidate is accepted as a side effect. Omit it for an ordinary proxy request.
 */
export const postV1RequestBusinessPartnerProxy = <ThrowOnError extends boolean = false>(options: Options<PostV1RequestBusinessPartnerProxyData, ThrowOnError>): RequestResult<PostV1RequestBusinessPartnerProxyResponses, PostV1RequestBusinessPartnerProxyErrors, ThrowOnError> => (options.client ?? client).post<PostV1RequestBusinessPartnerProxyResponses, PostV1RequestBusinessPartnerProxyErrors, ThrowOnError>({
    security: [{
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/requestBusinessPartner/proxy',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a particular business partner request related to current business partner
 *
 *  Delete a particular business partner request related to current business partner. <hr /> <br /> <br /> Requires bp_admin or sa_customer_admin role, otherwise responds with HTTP status **403**. <br /> If current business partner doesn't resolve, responds with HTTP status **403**. <br /> If id does not refer to a business partner request which is: for a division of current business partner; a proxy from current business partner, responds with HTTP status **404**. <br /> If the business partner request status is not one of `rejected`, `done` or `closed`, responds with HTTP status **409**.
 */
export const deleteV1RequestBusinessPartnerById = <ThrowOnError extends boolean = false>(options: Options<DeleteV1RequestBusinessPartnerByIdData, ThrowOnError>): RequestResult<DeleteV1RequestBusinessPartnerByIdResponses, DeleteV1RequestBusinessPartnerByIdErrors, ThrowOnError> => (options.client ?? client).delete<DeleteV1RequestBusinessPartnerByIdResponses, DeleteV1RequestBusinessPartnerByIdErrors, ThrowOnError>({
    security: [{
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/requestBusinessPartner/{id}',
    ...options
});

/**
 * Get a particular business partner request
 *
 *  Get a particular business partner request. <hr /> <br /> <br /> If id does not refer to a business partner request, responds with HTTP status **404**.
 */
export const getV1RequestBusinessPartnerById = <ThrowOnError extends boolean = false>(options: Options<GetV1RequestBusinessPartnerByIdData, ThrowOnError>): RequestResult<GetV1RequestBusinessPartnerByIdResponses, GetV1RequestBusinessPartnerByIdErrors, ThrowOnError> => (options.client ?? client).get<GetV1RequestBusinessPartnerByIdResponses, GetV1RequestBusinessPartnerByIdErrors, ThrowOnError>({
    security: [{
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/requestBusinessPartner/{id}',
    ...options
});

/**
 * Update a particular business partner request
 *
 *  Update a particular business partner request. <hr /> <br /> <br /> If id does not refer to a business partner, responds with HTTP status **404**. <br /> If the business partner request status is not `rejected` or `customer_review`, responds with HTTP status **409**. <br /> <br /> On success, if business partner request was `rejected`, responds with HTTP status **202** and the status is `accepted` and the request is in progress again.
 */
export const putV1RequestBusinessPartnerById = <ThrowOnError extends boolean = false>(options: Options<PutV1RequestBusinessPartnerByIdData, ThrowOnError>): RequestResult<PutV1RequestBusinessPartnerByIdResponses, PutV1RequestBusinessPartnerByIdErrors, ThrowOnError> => (options.client ?? client).put<PutV1RequestBusinessPartnerByIdResponses, PutV1RequestBusinessPartnerByIdErrors, ThrowOnError>({
    security: [{
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/requestBusinessPartner/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Accept business partner request
 *
 *  Accept a particular business partner request <hr /> <br /> <br /> If the business partner request doesn't exist, responds with HTTP status **404**. <br /> If the business partner request status is not `customer_review`, responds with HTTP status **409**.
 */
export const postV1RequestBusinessPartnerByIdAccept = <ThrowOnError extends boolean = false>(options: Options<PostV1RequestBusinessPartnerByIdAcceptData, ThrowOnError>): RequestResult<PostV1RequestBusinessPartnerByIdAcceptResponses, PostV1RequestBusinessPartnerByIdAcceptErrors, ThrowOnError> => (options.client ?? client).post<PostV1RequestBusinessPartnerByIdAcceptResponses, PostV1RequestBusinessPartnerByIdAcceptErrors, ThrowOnError>({
    security: [{
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/requestBusinessPartner/{id}/accept',
    ...options
});

/**
 * Decline business partner request
 *
 *  Decline a particular business partner request <hr /> <br /> <br /> If the business partner request doesn't exist, responds with HTTP status **404**. <br /> If the business partner request status is not `customer_review`, responds with HTTP status **409**.
 */
export const postV1RequestBusinessPartnerByIdDecline = <ThrowOnError extends boolean = false>(options: Options<PostV1RequestBusinessPartnerByIdDeclineData, ThrowOnError>): RequestResult<PostV1RequestBusinessPartnerByIdDeclineResponses, PostV1RequestBusinessPartnerByIdDeclineErrors, ThrowOnError> => (options.client ?? client).post<PostV1RequestBusinessPartnerByIdDeclineResponses, PostV1RequestBusinessPartnerByIdDeclineErrors, ThrowOnError>({
    security: [{
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/requestBusinessPartner/{id}/decline',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Generate registration token for business partner request owner
 *
 *  Generate a registration token for the owner of a business partner request. <hr /> <br /> <br /> This is authorized by the share link, so requires no permissions. <br /> The token is an HMAC-signed JWT containing the owner's email and a nonce, intended for use as the `register` parameter in the PingFederate registration invite flow. <br /> <br /> If the business partner request doesn't exist, responds with HTTP status **404**.
 */
export const postV1RequestBusinessPartnerByIdRegistrationToken = <ThrowOnError extends boolean = false>(options: Options<PostV1RequestBusinessPartnerByIdRegistrationTokenData, ThrowOnError>): RequestResult<PostV1RequestBusinessPartnerByIdRegistrationTokenResponses, PostV1RequestBusinessPartnerByIdRegistrationTokenErrors, ThrowOnError> => (options.client ?? client).post<PostV1RequestBusinessPartnerByIdRegistrationTokenResponses, PostV1RequestBusinessPartnerByIdRegistrationTokenErrors, ThrowOnError>({
    security: [{
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/requestBusinessPartner/{id}/registrationToken',
    ...options
});

/**
 * Get the business partner for the specified change ownership request
 *
 *  Gets the business partner for the specified ChangeOwnershipRequest <br /> This is authorized by the share link, so requires no permissions.
 */
export const getV1RequestChangeOwnershipById = <ThrowOnError extends boolean = false>(options: Options<GetV1RequestChangeOwnershipByIdData, ThrowOnError>): RequestResult<GetV1RequestChangeOwnershipByIdResponses, GetV1RequestChangeOwnershipByIdErrors, ThrowOnError> => (options.client ?? client).get<GetV1RequestChangeOwnershipByIdResponses, GetV1RequestChangeOwnershipByIdErrors, ThrowOnError>({
    security: [{
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/requestChangeOwnership/{id}',
    ...options
});

/**
 * Accepts the specified change ownership request
 *
 *  Accepts the specified change ownership request <br /> This is authorized by the share link, so requires no permissions. If the identity specified is already an owner of a business partner, or pending request business partner, responds with HTTP status **409** <br />
 */
export const postV1RequestChangeOwnershipByIdAccept = <ThrowOnError extends boolean = false>(options: Options<PostV1RequestChangeOwnershipByIdAcceptData, ThrowOnError>): RequestResult<PostV1RequestChangeOwnershipByIdAcceptResponses, PostV1RequestChangeOwnershipByIdAcceptErrors, ThrowOnError> => (options.client ?? client).post<PostV1RequestChangeOwnershipByIdAcceptResponses, PostV1RequestChangeOwnershipByIdAcceptErrors, ThrowOnError>({
    security: [{
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/requestChangeOwnership/{id}/accept',
    ...options
});

/**
 * Get the current roles (based on the token)
 */
export const getV1RolesCurrent = <ThrowOnError extends boolean = false>(options?: Options<GetV1RolesCurrentData, ThrowOnError>): RequestResult<GetV1RolesCurrentResponses, GetV1RolesCurrentErrors, ThrowOnError> => (options?.client ?? client).get<GetV1RolesCurrentResponses, GetV1RolesCurrentErrors, ThrowOnError>({
    security: [{
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/roles/current',
    ...options
});

/**
 * Create service agreement with customer
 *
 *  Create a service agreement with a business partner of a customer type `end_customer_enterprise` or `end_customer_individual`. <hr /> <br /> <br /> Requires sa_customer_admin role, otherwise responds with HTTP status **403**. <br /> If current business partner doesn't resolve, responds with HTTP status **403**. <br /> If current business partner type isn't `dealer`, responds with HTTP status **403**. <br /> If the customer business partner doesn't exist, responds with HTTP status **400**. <br /> If the customer business partner type isn't `end_customer_enterprise` or `end_customer_individual`, responds with HTTP status **409**. <br /> If the customer business partner has 3 or more service agreements, responds with HTTP status **409**. <br /> If there is an existing service agreement between current business partner and stated customer business partner, responds with HTTP status **409**. <br /> <br /> On success, responds with HTTP status **201** and new service agreement is created between the customer and provider. <br /> <br /> The new service agreement is consented by the provider, but not by the customer. <br /> <br /> Creating a service agreement may complete migration processing for migration candidates linked to the same dealer and customer. Matching candidates with overall status `accepted` or `matched` and `service_agreement_status = pending` are moved to `service_agreement_status = accepted`. <br /> <br /> Notifications are sent to the provider and customer.
 */
export const postV1ServiceAgreementWithCustomer = <ThrowOnError extends boolean = false>(options: Options<PostV1ServiceAgreementWithCustomerData, ThrowOnError>): RequestResult<PostV1ServiceAgreementWithCustomerResponses, PostV1ServiceAgreementWithCustomerErrors, ThrowOnError> => (options.client ?? client).post<PostV1ServiceAgreementWithCustomerResponses, PostV1ServiceAgreementWithCustomerErrors, ThrowOnError>({
    security: [{
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/serviceAgreement/withCustomer',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create service agreement with provider
 *
 *  Create a service agreement with a ServiceProvider (dealer). <hr /> <br /> <br /> Requires sa_sp_admin role, otherwise responds with HTTP status **403**. <br /> If current business partner doesn't resolve, responds with HTTP status **403**. <br /> If current business partner type isn't `end_customer_individual` or `end_customer_enterprise`, responds with HTTP status **403**. <br /> If current business partner has 3 or more service agreements, responds with HTTP status **409**. <br /> If the provider business partner doesn't exist, responds with HTTP status **400**. <br /> If the provider business partner type isn't `dealer`, responds with HTTP status **409**. <br /> If there is an existing service agreement between current business partner and stated customer business partner, responds with HTTP status **409**. <br /> <br /> On success, responds with HTTP status **201** and new service agreement is created between the customer and provider. <br /> <br /> The new service agreement is consented by the provider, but not by the customer. <br /> <br /> Creating a service agreement may complete migration processing for migration candidates linked to the same dealer and customer. Matching candidates with overall status `accepted` or `matched` and `service_agreement_status = pending` are moved to `service_agreement_status = accepted`. <br /> <br /> Notifications are sent to the provider and customer.
 */
export const postV1ServiceAgreementWithProvider = <ThrowOnError extends boolean = false>(options: Options<PostV1ServiceAgreementWithProviderData, ThrowOnError>): RequestResult<PostV1ServiceAgreementWithProviderResponses, PostV1ServiceAgreementWithProviderErrors, ThrowOnError> => (options.client ?? client).post<PostV1ServiceAgreementWithProviderResponses, PostV1ServiceAgreementWithProviderErrors, ThrowOnError>({
    security: [{
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/serviceAgreement/withProvider',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a particular service agreement
 *
 *  Delete a particular service agreement related to current business partner <hr /> <br /> <br /> Requires sa_customer_admin or sa_sp_admin role, otherwise responds with HTTP status **403**. <br /> If current business partner doesn't resolve, responds with HTTP status **403**. <br /> If the service agreement doesn't exist, responds with HTTP status **404**. <br /> If current business partner is not either the provider, or the customer of the service agreement, responds with HTTP status **404**.
 */
export const deleteV1ServiceAgreementById = <ThrowOnError extends boolean = false>(options: Options<DeleteV1ServiceAgreementByIdData, ThrowOnError>): RequestResult<DeleteV1ServiceAgreementByIdResponses, DeleteV1ServiceAgreementByIdErrors, ThrowOnError> => (options.client ?? client).delete<DeleteV1ServiceAgreementByIdResponses, DeleteV1ServiceAgreementByIdErrors, ThrowOnError>({
    security: [{
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/serviceAgreement/{id}',
    ...options
});

/**
 * Get a particular service agreement
 *
 *  Get a particular service agreement related to current business partner <hr /> <br /> <br /> Requires sa_customer_admin or sa_sp_admin role, otherwise responds with HTTP status **403**. <br /> If current business partner doesn't resolve, responds with HTTP status **403**. <br /> If the service agreement doesn't exist, responds with HTTP status **404**. <br /> If current business partner is not either the provider, or the customer of the service agreement, responds with HTTP status **404**.
 */
export const getV1ServiceAgreementById = <ThrowOnError extends boolean = false>(options: Options<GetV1ServiceAgreementByIdData, ThrowOnError>): RequestResult<GetV1ServiceAgreementByIdResponses, GetV1ServiceAgreementByIdErrors, ThrowOnError> => (options.client ?? client).get<GetV1ServiceAgreementByIdResponses, GetV1ServiceAgreementByIdErrors, ThrowOnError>({
    security: [{
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/serviceAgreement/{id}',
    ...options
});

/**
 * Update a particular service agreement
 *
 *  Update a particular service agreement related to current business partner <hr /> <br /> <br /> Requires sa_customer_admin or sa_sp_admin role, otherwise responds with HTTP status **403**. <br /> If current business partner doesn't resolve, responds with HTTP status **403**. <br /> If the service agreement doesn't exist, responds with HTTP status **404**. <br /> If the upsert results in no change, responds with HTTP status **200**. <br /> <br /> Changing the terms of the service agreement will require the other party to re-consent to the service agreement. Notifications will be sent to both parties regarding the change.
 */
export const putV1ServiceAgreementById = <ThrowOnError extends boolean = false>(options: Options<PutV1ServiceAgreementByIdData, ThrowOnError>): RequestResult<PutV1ServiceAgreementByIdResponses, PutV1ServiceAgreementByIdErrors, ThrowOnError> => (options.client ?? client).put<PutV1ServiceAgreementByIdResponses, PutV1ServiceAgreementByIdErrors, ThrowOnError>({
    security: [{
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/serviceAgreement/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Accept service agreement request
 *
 *  Accept a service agreement request where current business partner is the invitee <hr /> <br /> <br /> Requires bp_admin role, otherwise responds with HTTP status **403**. <br /> If current business partner doesn't resolve, responds with HTTP status **403**. <br /> If the service agreement doesn't exist, responds with HTTP status **404**. <br /> If the service agreement status is not `invited`, responds with HTTP status **409**. <br /> If current business partner is not either the provider, or the customer of the service agreement, responds with HTTP status **404**.
 */
export const postV1ServiceAgreementByIdAccept = <ThrowOnError extends boolean = false>(options: Options<PostV1ServiceAgreementByIdAcceptData, ThrowOnError>): RequestResult<PostV1ServiceAgreementByIdAcceptResponses, PostV1ServiceAgreementByIdAcceptErrors, ThrowOnError> => (options.client ?? client).post<PostV1ServiceAgreementByIdAcceptResponses, PostV1ServiceAgreementByIdAcceptErrors, ThrowOnError>({
    security: [{
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/serviceAgreement/{id}/accept',
    ...options
});

/**
 * Decline service agreement request
 *
 *  Decline a service agreement request where current business partner is the invitee <hr /> <br /> <br /> Requires bp_admin role, otherwise responds with HTTP status **403**. <br /> If current business partner doesn't resolve, responds with HTTP status **403**. <br /> If the service agreement doesn't exist, responds with HTTP status **404**. <br /> If the service agreement status is not `invited`, responds with HTTP status **409**. <br /> If current business partner is not either the provider, or the customer of the service agreement, responds with HTTP status **404**.
 */
export const postV1ServiceAgreementByIdDecline = <ThrowOnError extends boolean = false>(options: Options<PostV1ServiceAgreementByIdDeclineData, ThrowOnError>): RequestResult<PostV1ServiceAgreementByIdDeclineResponses, PostV1ServiceAgreementByIdDeclineErrors, ThrowOnError> => (options.client ?? client).post<PostV1ServiceAgreementByIdDeclineResponses, PostV1ServiceAgreementByIdDeclineErrors, ThrowOnError>({
    security: [{
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/serviceAgreement/{id}/decline',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List service agreements with customers
 *
 *  List service agreements with customers of current business partner (dealer). <hr /> <br /> <br /> Requires is_sa_customer_admin role, otherwise responds with HTTP status **403**. <br /> If current business partner doesn't resolve, responds with HTTP status **403**. <br /> If current business partner type isn't `dealer`, responds with HTTP status **403**. <br /> **scope** query parameter controls which providers are included: `current` (default), `children`, or `currentAndChildren`. Only immediate child providers are included; grandchildren are excluded. Parent visibility is read-only; mutations remain limited to the actual service agreement parties. <br /> **filter[providerBusinessPartnerId][in]** narrows results to the specified provider IDs within the requested scope. IDs outside the scope are silently excluded. <br /> Standard `page`, `limit`, and `filter` parameters are applied together with scope in a single combined query against Directus/PostgreSQL. `sort` is not configurable for this route; results are always ordered deterministically by provider name, then by service agreement ID as a stable tie-breaker.
 */
export const getV1ServiceAgreementsWithCustomer = <ThrowOnError extends boolean = false>(options?: Options<GetV1ServiceAgreementsWithCustomerData, ThrowOnError>): RequestResult<GetV1ServiceAgreementsWithCustomerResponses, GetV1ServiceAgreementsWithCustomerErrors, ThrowOnError> => (options?.client ?? client).get<GetV1ServiceAgreementsWithCustomerResponses, GetV1ServiceAgreementsWithCustomerErrors, ThrowOnError>({
    security: [{
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/serviceAgreements/withCustomer',
    ...options
});

/**
 * List service agreements with service providers (dealers)
 *
 *  List service agreement with service providers (dealers) for current business partner. <hr /> <br /> <br /> Requires sa_sp_admin role, otherwise responds with HTTP status **403**. <br /> If current business partner doesn't resolve, responds with HTTP status **403**. <br /> If current business partner type isn't `end_customer_enterprise` or `end_customer_individual`, responds with HTTP status **403**.
 */
export const getV1ServiceAgreementsWithProvider = <ThrowOnError extends boolean = false>(options?: Options<GetV1ServiceAgreementsWithProviderData, ThrowOnError>): RequestResult<GetV1ServiceAgreementsWithProviderResponses, GetV1ServiceAgreementsWithProviderErrors, ThrowOnError> => (options?.client ?? client).get<GetV1ServiceAgreementsWithProviderResponses, GetV1ServiceAgreementsWithProviderErrors, ThrowOnError>({
    security: [{
            key: '0-ciam-switch-bp',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: '1-ciam-switch-nobp',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/serviceAgreements/withProvider',
    ...options
});
